// extracted by mini-css-extract-plugin
export var error = "SupportTicketModal-module--error--oQ6ID";
export var form = "SupportTicketModal-module--form--oQL22";
export var welcomeContent = "SupportTicketModal-module--welcomeContent--G23bs";